import React from 'react';
import { inject, observer } from "mobx-react";


const Transaction = (tx) => {
  const {name, hash, status} = tx.tx;
  let classname;
  switch(status){
    case 'mined':
      classname = 'table-td_check-hash_done'
      break;
    case 'error':
      classname = 'table-td_check-hash_error'
      break;
    case 'pending':
      classname = 'table-td_check-hash_wait'
      break;
    default:
      classname = 'table-td_check-hash_wait'
  }
  // const classname = status === 'mined' ? 'table-td_check-hash_done' : 'table-td_check-hash_wait'
  const statusLabels = {
    mined: '已确认',
    error: '错误',
    pending: '待确认'
  }
  return (
    <div className="table-tr">
      <div className={`table-td table-td_check-hash ${classname}`}>
        交易哈希: <a target="_blank" href={`${tx.explorerUrl}/tx/${hash}`}>{hash}</a> <br/> {name} <br/> 状态：{statusLabels[status]}
      </div>
    </div>
  )
}
@inject("UiStore")
@observer
export class FourthStep extends React.Component {
  constructor(props){
    super(props);
    this.txStore = props.UiStore.txStore;
    this.tokenStore = props.UiStore.tokenStore;
    this.totalNumberTx = props.UiStore.tokenStore.totalNumberTx;
    console.log(this.totalNumberTx, 'from store')
    this.explorerUrl = props.UiStore.web3Store.explorerUrl;
    this.state = {
      txCount: Number(this.totalNumberTx)
    }
  }
  componentDidMount(){
    try {
      this.txStore.doSend()
    } catch(e){
      console.log('FROM UI', e)
    }
  }
  render () {
    let totalNumberOftx;
    
    if(Number(this.tokenStore.totalBalance) > Number(this.tokenStore.allowance)){
      totalNumberOftx = Number(this.totalNumberTx) + 1;
    } else {
      totalNumberOftx = Number(this.totalNumberTx)
    }

    const txHashes = this.txStore.txs.map((tx, index) => {
      return <Transaction key={index} tx={{...tx}} explorerUrl={this.explorerUrl}/>
    })
    let status;
    if(this.txStore.txs.length === totalNumberOftx){
      status =  "全部交易已发送完成，请等待交易确认。技术支持电报：@defiplot"
    } else {
      const txCount = totalNumberOftx - this.txStore.txs.length
      status = `请在Metamask中签名 ${txCount} 个交易...`
    }
    return (
      <div className="container container_bg">
        <div className="content">
          <h1 className="title">欢迎使用 <strong>AirDroper</strong>批量发送工具。</h1>
          <p className="description">
            你可以使用 <b>AirDroper</b> 批量转账以太币或ERC20代币，
            一键完成大量地址的代币分发任务。
          </p>
          <form className="form">
            <p>{status}</p>
            <div className="table">
              {txHashes}
            </div>
            {/* <Link className="button button_next" to='/5'>Back to Home</Link> */}
          </form>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/4.js